module.exports = __webpack_public_path__ + "img/sandra.bdf6d00b.png";